import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'formatDate'
})
export class FormatDatePipe implements PipeTransform {
    transform(value: any, args?: any): any {
        const format = args && args.format ? args.format : 'YYYY-MM-DD HH:mm';
        if (value.match(/^\d{4}-\d{2}-\d{2}$/)) {
            return moment(value, 'YYYY-MM-DD').format(format);
        } else if (value.match(/^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/)) {
            return moment(value, 'YYYY-MM-DD HH:mm:ss').format(format);
        } else if (typeof value === 'number') {
            return moment(value, 'X').format(format);
        } else if (value instanceof Date) {
            return moment(value).format(format);
        } else {
            return value;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/common/pipes/format-date.pipe.ts